import {
  Heading,
  Icon,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { format } from 'date-fns';
import { FaCheck, FaXmark } from 'react-icons/fa6';
import { useOrderModalContext } from '../ModalContext';
const OrderLogHistory = () => {
  const { transactions, editing } = useOrderModalContext();

  return transactions.length && !editing ? (
    <Stack mt="2rem">
      <Heading size="md">Histórico de cobranças</Heading>
      <TableContainer whiteSpace="break-spaces">
        <Table size="sm">
          <Thead>
            <Tr>
              <Th>Bandeira</Th>
              <Th w={'100px'}>Últimos dígitos</Th>
              <Th>Sucesso</Th>
              <Th>Token da Cobrança</Th>
              <Th w={'180px'}>Data</Th>
            </Tr>
          </Thead>
          <Tbody>
            {transactions.map((transaction) => (
              <Tr key={transaction.id}>
                <Td>{transaction.credit_card_brand}</Td>
                <Td>{transaction.credit_card_last_digits}</Td>
                <Td>
                  <Icon
                    as={transaction.success ? FaCheck : FaXmark}
                    mx="auto"
                    display="block"
                    color={transaction.success ? 'yooga.600' : 'red.500'}
                  />
                </Td>
                <Td>{transaction.message}</Td>
                <Td>{format(transaction.created_at, 'dd/MM/yyyy HH:mm:ss')}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Stack>
  ) : (
    <></>
  );
};

export default OrderLogHistory;
